import { render, staticRenderFns } from "./ReportDesktopOrdered.vue?vue&type=template&id=11c465da"
import script from "./ReportDesktopOrdered.vue?vue&type=script&lang=js"
export * from "./ReportDesktopOrdered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports